import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=a21cc662"
import script from "./FAQ.vue?vue&type=script&lang=ts&setup=true"
export * from "./FAQ.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=a21cc662&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports